import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue"

const _hoisted_1 = {
  class: "BrowserContainer",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "浏览器信息", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import BrowserTypeList from './BrowserTypeList.vue';
import BrowserInfoList from './BrowserInfoList.vue';
import BrowserSearchList from './BrowserSearchList.vue';
import { BrowserMutations } from '@/store/modules/browser';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { computed, ref, onMounted, onUnmounted, onBeforeMount, Ref, DefineComponent } from 'vue';
import { BrowserGetters } from '@/store/modules/browser';
import { SearchTabNode } from '@/store/modules/browser/types';


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "BrowserContainer",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const activeTab = ref<SearchTabNode>()

const store = useStore();
const browserTypeListRef: Ref<(typeof BrowserTypeList) | null> = ref(null)
const popoverVisible = ref<boolean>(false)
const isSearching = computed(() => {
    return store.getters[`browser/${BrowserGetters.getIsSearching}`]
});
const browserTaskIdList = computed(() => {
    return store.getters[`browser/${BrowserGetters.getTaskIdList}`]
});
const searchTabList = computed(() => {
    return store.getters[`browser/${BrowserGetters.getSearchTabList}`]
});

const searchTarget = computed(() => {
    return store.getters[`browser/${BrowserGetters.getSearchTarget}`]
})
const searchFilter = computed(() => {
    return store.getters[`browser/${BrowserGetters.getSearchFilter}`]
})
const selectedTaskId = computed(() => {
    return store.getters[`browser/${BrowserGetters.getSelectedTaskId}`]
});
const handleCloseDialog = () => {
    store.commit(`browser/${BrowserMutations.setIsSearching}`, false);
}
const handleOpenDialog = () => {
    activeTab.value = searchTabList.value.length !== 0 ? searchTabList.value[searchTabList.value.length - 1] : {}
}
const handleClose = (targetTab: SearchTabNode) => {
    const newList = searchTabList.value.filter((tab: SearchTabNode) => tab !== targetTab)
    store.commit(`browser/${BrowserMutations.deleteSearchTabList}`, newList);
    activeTab.value = searchTabList.value.length !== 0 ? searchTabList.value[searchTabList.value.length - 1] : {}
}
const handleChooseTime = async (taskId: string) => {
    store.commit(`browser/${BrowserMutations.resetForChangeTask}`);
    store.commit(`browser/${BrowserMutations.setSelectedTaskId}`, taskId)
    if (browserTypeListRef.value !== null) {
        browserTypeListRef.value.handleChangeTask()
    }
}
const getDisplayTime = (data: string) => {
    const date = (new Date(new Date(new Date(data).toUTCString()).getTime() + 8 * 60 * 60 * 1000)).toISOString()
    return date.substring(0, 10) + "  " + date.substring(11, 19)
}

onUnmounted(() => {
    store.commit(`browser/${BrowserMutations.resetAll}`);
});


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_popover, {
        placement: "bottom",
        title: " ",
        width: 400,
        trigger: "hover"
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"float":"right","margin-right":"50px","margin-top":"10px"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (popoverVisible.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode("切换时间")
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          (_unref(browserTaskIdList) !== null && _unref(browserTaskIdList).length !== 0)
            ? (_openBlock(), _createBlock(_component_el_timeline, {
                key: 0,
                class: "TimeLinePopover"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(browserTaskIdList), (timeNode, index) => {
                    return (_openBlock(), _createBlock(_component_el_timeline_item, {
                      key: index,
                      timestamp: getDisplayTime(timeNode.updateAt),
                      onClick: ($event: any) => (handleChooseTime(timeNode.id)),
                      type: timeNode.id === _unref(selectedTaskId) ? 'primary' : ''
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(timeNode.id), 1)
                      ]),
                      _: 2
                    }, 1032, ["timestamp", "onClick", "type"]))
                  }), 128))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, " 浏览器任务旧标准，不支持按任务筛选"))
        ]),
        _: 1
      }),
      _hoisted_3
    ]),
    _createVNode(BrowserTypeList, {
      ref_key: "browserTypeListRef",
      ref: browserTypeListRef
    }, null, 512),
    _createVNode(BrowserInfoList),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(isSearching),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(isSearching) ? (isSearching).value = $event : null)),
      width: "90%",
      title: '“' + _unref(searchTarget) + '”在' + (_unref(searchFilter) ? 'task “' + _unref(selectedTaskId) + '”' : '全量数据') + '上的搜索结果',
      onClose: handleCloseDialog,
      onOpen: handleOpenDialog
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tabs, {
          modelValue: activeTab.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event)),
          closable: "",
          onTabRemove: handleClose
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchTabList), (tab, index) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: tab,
                name: tab,
                lazy: ""
              }, {
                label: _withCtx(() => [
                  _createVNode(_component_el_popover, {
                    width: 400,
                    placement: "top-start"
                  }, {
                    reference: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tab.searchTarget + '(' + (tab.searchTaskId === 'all' ? 'all' :
                                    getDisplayTime(tab.searchTask.createAt)) + ')'), 1)
                    ]),
                    default: _withCtx(() => [
                      (tab.searchTaskId === 'all')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createTextVNode(" 任务ID: "),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(browserTaskIdList), (taskNode, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(taskNode.id), 1))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createTextVNode(" 任务ID: "),
                            _createElementVNode("li", null, _toDisplayString(tab.searchTaskId), 1)
                          ]))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(BrowserSearchList, {
                    searchTarget: activeTab.value!.searchTarget,
                    searchTaskId: activeTab.value!.searchTaskId
                  }, null, 8, ["searchTarget", "searchTaskId"])
                ]),
                _: 2
              }, 1032, ["name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})